/**
 * DOM köməkçiləri.
 *
 * ⚠ QAYDA: bu app-da DOM BİR DƏFƏ qurulur, sonra yalnız MUTASİYA olunur.
 * Naviqasiya zamanı `createElement` çağırılmır, `innerHTML` yenidən yazılmır —
 * çünki hər ikisi köhnə TV-də tam yenidən layout + paint deməkdir və pult
 * düyməsinin cavabını 300-800 ms gecikdirir. Məhz bu gecikmə «donma» kimi
 * qavranılır.
 */

/** Elementi bir çağırışda qurur — atribut/mətn üçün ayrıca sətir lazım deyil. */
export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  text?: string,
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag)
  if (className) node.className = className
  if (text !== undefined) node.textContent = text
  return node
}

/** ID üzrə element tapır (tip çevirməsi ilə). */
export function byId<T extends HTMLElement>(id: string): T {
  const node = document.getElementById(id)
  if (!node) throw new Error(`#${id} tapılmadı`)
  return node as T
}

/** `classList.toggle(name, force)`-un ikinci arqumenti Chrome 24+; yenə də açıq yazırıq. */
export function setClass(node: HTMLElement, name: string, on: boolean): void {
  if (on) {
    if (!node.classList.contains(name)) node.classList.add(name)
  } else if (node.classList.contains(name)) {
    node.classList.remove(name)
  }
}

/**
 * Yeganə icazəli «animasiya» yolu: `translate3d`.
 *
 * ⚠ `translate3d` (3d!) qəsdəndir — 2d variant köhnə TV-də compositor layer
 * yaratmır və hər kadrda yenidən paint olunur. `left`/`top` isə ümumiyyətlə
 * layout tetikleyir.
 */
export function translate(node: HTMLElement, x: number, y: number): void {
  const value = `translate3d(${Math.round(x)}px, ${Math.round(y)}px, 0)`
  node.style.transform = value
  // webOS 3 / Tizen 2.4 prefiksli mühərriklər üçün.
  node.style.setProperty('-webkit-transform', value)
}

/** Mətni yalnız DƏYİŞİBSƏ yazır — eyni mətni təkrar yazmaq da paint tetikleyir. */
export function setText(node: HTMLElement, text: string): void {
  if (node.textContent !== text) node.textContent = text
}

/** Elementin bütün uşaqlarını silir. */
export function clear(node: HTMLElement): void {
  while (node.firstChild) node.removeChild(node.firstChild)
}
